var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.uid.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.uid.js
// module chunks = 0